import { combineReducers } from "redux";
import orbatReducer from "store/reducers/orbat.reducer";
import coreReducer from "store/reducers/core.reducer";
import discordReducer from "store/reducers/discord.reducer";
import raffleReducer from "store/reducers/raffle.reducer";

export const rootReducer = combineReducers({
  orbat: orbatReducer,
  core: coreReducer,
  discord: discordReducer,
  raffle: raffleReducer,
});
